﻿$.fn.dxCtrlReinitPwd = function custom_dxCtrlReinitPwd(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlreinitpwd dx-ctrl");
        this.createInstance(new cdxCtrlReinitPwd(this, option));
    }
    return this;
}

window.idxCarousselGeneral = 0
window.cdxCtrlReinitPwd = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    var $DivContainer = null
    function mConstruit() {
        container.empty();
        container.css({
            "display": "flex",
            "align-items": "center",
            "justify-content": "center"
        })
        $DivContainer = $("<div text-align:center;/>").appendTo(container)

        if (option.token == null) {
            mConstruitReinitPwdKo("Le lien du mot de passe n'existe pas.")
        } else if (option.token.length == 0) {
            mConstruitReinitPwdKo("Le lien du mot de passe est expiré.")
        } else {
            mConstruitReinitPwdOk()
        }

    }

    function mRempliEntete() {
        $("<a href='" + parametre.url_site_vitrine + "' style='font-size:120%;position:absolute;bottom:10px;left:10px;' target='_blank'>" + parametre.url_site_vitrine + "</a>").appendTo($DivContainer)

        var $DivBoxLogin = $("<div style='width:100%;'/>").appendTo($DivContainer);
        $DivBoxLoginCenter = $("<div style='width:100%;padding:25px 0 20px 0;border-radius:10px;border:1px transparent solid;text-align:left;'/>").appendTo($DivBoxLogin);

        $(document).attr("title", parametre.nom)
        if (document.URLRacine.startsWith("https://portail")) {
            var link = $("link[rel*='icon']").first();
            link.attr("href", parametre.baseAppli.img_logo_portail);
            $(document).attr("title", "Portail " + parametre.baseAppli.nom);
        }

        var $DivImg = $("<div style='text-align:center;'/>").appendTo($DivBoxLoginCenter)
        var $DivImg = $("<div style='text-align:center;'/>").appendTo($DivBoxLoginCenter)
        var $Img = $("<img src='" + parametre.img + "' style='width:70px'/>").appendTo($DivImg)

        var $Div = $("<div class='dx-theme-accent-as-background-color'/>").appendTo($DivContainer);
        backgroundcolorAccent = $Div.css("background-color");
        $Div.remove();
        $("<div style='font-size:24px;font-weight:bold;color: white;text-shadow: 1px 1px 2px black, 0 0 2px " + backgroundcolorAccent + ", 0 0 5px " + backgroundcolorAccent + ";'>" + parametre.nom + "</div>").appendTo($DivImg)

        $("<div style='font-size:180%;'>Nouveau mot de passe</div>").appendTo($DivImg)
    }

    function mConstruitReinitPwdKo(txt) {
        $DivContainer.empty()
        mRempliEntete()
        var $DivReinit = $("<div style='text-align:center;padding:10px'/>").appendTo($DivContainer);
        $("<div style='font-size:120%;'>" + txt + "</div>").appendTo($DivReinit)
        $("<br/>").appendTo($DivContainer)
        var $DivLinkRetour = $("<div style='text-align:center;'/>").appendTo($DivContainer)
        $("<a href='" + window.location.origin + "' target='_self'>Retourner sur " + parametre.nom + "</a>").appendTo($DivLinkRetour)
    }

    function mConstruitReinitPwdOk() {
        $DivContainer.empty()
        mRempliEntete()
        $("<div style='text-align:center;'>Vous avez demandé à pouvoir réinitialiser<br/>le mot de passe de votre compte.<br/>Veuillez saisir votre nouveau mot de passe.</div>").appendTo($DivContainer)
        $("<br/>").appendTo($DivContainer)
        $("<br/>").appendTo($DivContainer)

        dxCtrlPwd = $("<div style='width:250px;padding:0 10px;'/>").appendTo($DivContainer).dxCtrlPwd({
            value: ""
            //onValueChanged: function (value) { data.pwd = value; }
        }).dxCtrlPwd("instance")
        window.setTimeout(function () { dxCtrlPwd.focus() }, 500)

        var $DivBt = $("<div style='text-align:center;padding-top:30px'/>").appendTo($DivContainer)
        var dxBtValide = $("<div/>").appendTo($DivBt).dxButton({
            text: "Réinitialiser le mot de passe",
            onClick: function (e) {
                if (dxCtrlPwd.isOk()) {
                    jaugeDemarrage.mShow();
                    option.bddCtrl.mAjaxCall({
                        command:"reinitpwdwithtoken",
                        newpwd: dxCtrlPwd.option("value"),
                        token: option.token
                    }, function (data) {
                        if (data.expire != 'undefined' && data.expire == "1") {
                            mConstruitReinitPwdKo("Le lien du mot de passe est expiré.")
                        } else if (data.pastrouve != 'undefined' && data.pastrouve == "1") {
                            mConstruitReinitPwdKo("Le lien du mot de passe n'existe plus.")
                        } else if (data.update != 'undefined' && data.update == "1") {
                            mConstruitReinitPwdKo("Votre mot de passe a été mis à jour.")
                        } else { mConstruitReinitPwdKo("Impossible de mettre à jour le mot de passe.") }
                        jaugeDemarrage.mHide();
                    })
                } else { mNotify("La saisie de votre mot de passe est erroné, veuillez vérifier celle-ci.", "warning", 6000); }
            }
        }).dxButton("instance");

        $("<br/>").appendTo($DivContainer)
        var $DivLinkRetour = $("<div style='text-align:center;'/>").appendTo($DivContainer)
        $("<a href='" + window.location.origin + "' target='_self'>Retourner sur " + parametre.nom + "</a>").appendTo($DivLinkRetour)
    }

    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();
}